import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueLazyload from "vue-lazyload";
import "./assets/tailwind.css";
import { MotionPlugin } from "@vueuse/motion";
import { initAttribution } from "./services/attribution";

// Seed the visitor/session ids and capture the landing URL's campaign tags
// before anything renders, so the very first interaction is attributable.
initAttribution();

const app = createApp(App);

app.use(router);

app.use(VueLazyload, {
  loading: require("@/assets/logos/loading.webp"), // Ensure these paths are correct
});

app.use(MotionPlugin);

app.mount("#app");
